import { Widget } from '@sprinklr/stories/widget/Widget';
import { Theme } from 'models/Theme/Theme';
import { CollapseProps, TunablesCollapse } from 'components/Sidebar/RenderTunables/RenderTunables';
import i18n from 'i18next';
import { headerTunables, opacityTunables } from 'components/Sidebar/RenderTunables/SharedTunables';
import React from 'react';
import ActionCheckboxGroup from 'components/_UI/Forms/Actions/ActionCheckboxGroup';
import {
    legendTunables,
    metaInfoTunables,
    metricGroupTunables,
} from 'components/Sidebar/RenderTunables/HyperspaceSharedTunables';
import ActionCheckboxSliderGroup from 'components/_UI/Forms/Actions/ActionCheckboxSliderGroup';

export const HyperSpacePieChartWidgetTunables = (
    widget: Widget,
    mergedTheme: Theme
): TunablesCollapse[] => [
    {
        props: {
            label: i18n.t('Pie Chart'),
            startOpen: true,
        } as CollapseProps,
        children: [
            ...headerTunables(widget),
            opacityTunables(widget),
            <ActionCheckboxGroup
                key='dataLabelOptions'
                label={i18n.t('Data Labels')}
                option={widget.options.dataLabelOptions}
                value='enabled'
            />,
            <ActionCheckboxSliderGroup
                key='donutWidth'
                label={i18n.t('Adjust Donut Width')}
                showValue
                checkbox={{
                    option: widget.options.donutWidth,
                    value: 'enabled',
                }}
                slider={{
                    option: widget.options.donutWidth,
                    value: 'size',
                    min: 5,
                    max: 525,
                }}
            />,
        ],
    },
    metricGroupTunables(widget),
    metaInfoTunables({ widget, color: true, image: false }),
    legendTunables(widget),
];
